<!-- <app-loading-progress *ngIf="routeLoading" [value]="routeLoadingProgress" [transparentBackground]="true" class="scg-loading-progressbar"></app-loading-progress> -->
<router-outlet></router-outlet>
